import API from '@/services/endpoint'
import {RESET_CURRENT_USER, FETCH_CURRENT_USER, SET_TOKEN} from "../../mutation-types";

/**
 * API Post Request to fetch the current user
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @param  {object} payload comes from login vue
 * @return {object[]} A array of information about the current user
 */
export async function fetchCurrentUser({commit, state}, payload) {
  return new Promise(async(resolve, reject) => {
    try {
      const { loginUrl } = state;
      let responseObj = await API.post(loginUrl, payload);
      let { data: { message: { user, token } } } = responseObj;
      commit(FETCH_CURRENT_USER, user)
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      resolve(responseObj.data)
    } catch (e) {
      // Safely access response data, fallback to error message if response is undefined
      const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
      reject(errorData)
    }
  })
}

/**
 * API get Request to check the current user
 * @param commit
 * @param state
 * @returns {Promise<unknown>}
 */
export async function checkUser({commit, state}) {
  return new Promise(async(resolve, reject) => {
    try {
      const { checkUserUrl } = state;
      let responseObj = await API.get(checkUserUrl);
      let { data: { message: { success } } } = responseObj;
      resolve(responseObj.data)
    } catch (e) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      commit(RESET_CURRENT_USER)
      // Safely access response data, fallback to error message if response is undefined
      const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
      reject(errorData)
    }
  })
}

/**
 * API POST Request to register new user
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @param  {object} payload comes from register vue
 * @return {object[]} A array of information about the current user
 */
export async function registerHandler({commit, state}, payload) {
  return new Promise(async(resolve, reject) => {
    try {
      const { registerUrl } = state;
      let responseObj = await API.post(registerUrl, payload);
      let { data: { message: { user, token } } } = responseObj;
      commit(FETCH_CURRENT_USER, user)
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      resolve(responseObj.data)
    } catch (e) {
      // Safely access response data, fallback to error message if response is undefined
      const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
      reject(errorData)
    }
  })
}

/**
 * Logout
 * * @param {function} commit - The vuex commit function
 */
export async function logoutHandler({commit}) {
    localStorage.removeItem('user')
    localStorage.removeItem('token')
    commit(RESET_CURRENT_USER)
    window.location.href = '/'
}

/**
 * Send Reset E-Mail
 * * @param {function} commit - The vuex commit function
 * * @param {object} state - The vuex state object
 * * @param {string} payload - the email to be sent to the API
 * @return {object} the status after sending the email
 */
export async function sendResetMailHandler({commit, state}, payload) {
  let { sendResetMailUrl } = state
  let responseObj = await API.post(sendResetMailUrl, payload)
  return Promise.resolve(responseObj.data)
}

/**
 * Check reset token
 * * @param {function} commit - The vuex commit function
 * * @param {object} state - The vuex state object
 * * @param {string} payload - token to be sent
 * @return {object} the status after the token
 */
export async function checkResetToken({commit, state}, payload) {
  try {
    let { checkResetTokenUrl } = state
    let responseObj = await API.post(checkResetTokenUrl, payload);
    let { data: {success} } = responseObj;
    if ( success ) commit(SET_TOKEN, payload)
    return Promise.resolve(success);
  } catch (e) {
    // Safely access response data, fallback to error message if response is undefined
    const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
    return Promise.reject(errorData)
  }
}


/**
 * Reset Password
 * * @param {function} commit - The vuex commit function
 * * @param {object} state - The vuex state object
 * * @param {object} payload - new password and password confirmation with token
 * @return {object} will return the user object
 */
export async function resetPasswordHandler({commit, state}, payload) {
  let responseObj;
  try {
    let { resetUrl, updatePasswordUrl } = state;
    let { password, password_confirmation, isUpdated } = payload
    if ( isUpdated ) {
      responseObj = await API.put(updatePasswordUrl, {password, password_confirmation})
    } else {
      responseObj = await API.put(resetUrl, payload);
    }
    let { data: { success } } = responseObj;
    return Promise.resolve(success);
  } catch (e) {
    // Safely access response data, fallback to error message if response is undefined
    const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
    return Promise.reject(errorData)
  }
}

